<template>
  <div class="position-relative">
    <section class="section-shaped my-0 py-2">
      <div class="shape shape-style-1 shape-primary shape-skew">
      </div>
      <div class="container pt-lg custom-padding-bottom-cover">
      <v-wait for="titulo.ficha.load" transition="fade" :duration="750"> 
        <template slot="waiting">
          <div class="row justify-content-between align-items-center">
            <div class="col-lg-6 mb-lg-auto">
                <div class="rounded overflow-hidden transform-perspective-left">
                    <card type="secondary"
                      :class="['capa-filme']"
                      bodyClasses="p-1 bg-white border-0">
                      <template>
                          <div class="ph-col-12 ph-cover"></div>
                      </template>
                    </card>
                </div>
            </div>
            <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="ph-container">
                  <div class="ph-col-12 ph-title mb-2"></div>
                  <div class="ph-col-10 clear ph-subtitle"></div>
                  <div class="ph-col-5 ph-text"></div>
                </div>
            </div>
          </div>
        </template>
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6 mb-lg-auto">
              <div class="rounded overflow-hidden transform-perspective-left">
                  <card type="secondary"
                    :class="['capa-filme']"
                    bodyClasses="p-1 bg-white border-0">
                    <template>
                        <img v-lazy="capa" class="card-img-top" v-if="!$wait.is('titulo.ficha.load')">
                          <div class="lazyOverlay">
                            <img src="img/tail-spin.svg">
                        </div>
                    </template>
                  </card>
              </div>
          </div>
          <div class="col-lg-6 mb-5 mb-lg-0">
            <h1 class="text-white display-2 movie-title">{{movie.titulo_traduzido}}<span>{{movie.titulo_original}} ({{movie.ano}})</span></h1>
            <p class="lead categoria text-white mt-2 mb-0">{{movie.genero}} - {{movie.duracao}}min</p>
            <p class="lead dublagem mt-1" v-if="movie.procuro">
              <span class="badge badge-white text-default mb-4 d-table">dublagem indisponível</span>
              <base-button type="success" icon="fa fa-film" @click="redirectContact()">
                  Tenho esse Filme Dublado
              </base-button>
            </p>
            <p class="lead dublagem mt-1" v-else>
              <span class="text-white font-weight-bold"><small>Última atualização: {{movie.ultima_atualizacao}}</small></span>
              <span class="badge badge-white text-default mb-4 d-table" v-if="movie.midias.length > 0">títulos disponíveis: {{movie.midias.length}}</span>
              <span class="badge badge-white text-default mb-4 d-table" v-else>nenhuma dublagem disponível</span>
              <base-button type="success" icon="fa fa-film" v-if="movie.midias.length > 0" @click="goToMedia()">
                  Ver Mídias
              </base-button>
              <base-button type="primary" v-if="movie.elenco_dublagem.length > 0" icon="fa fa-microphone" @click="goToElencoDublagem()">
                  Elenco de Dublagem
              </base-button>
              <span class="text-white aka" v-if="movie.outros_titulos"><small><strong>Também conhecido como:</strong><br>{{movie.outros_titulos}}</small></span>
            </p>
          </div>
        </div>
      </v-wait>
      </div> 
    </section>
  </div>
</template>
<script>

import {scrollPageTo} from '@/plugins/scrollPageTo';

export default {
  name: 'movieHeaderHero',
  computed: {
    movie() {
      return this.$store.state.catalog.movie;
    },
    capa() {
      return this.axios.defaults.baseURL + this.movie.capa;
    },
    movieString() {
      return `${this.movie.titulo_original} (${this.movie.ano})`;
    }
  },
  methods: {
    redirectContact() {
      const subjectContact = this.movieString;
      this.$router.push({ name: 'contato', 
                          query: { assunto: subjectContact || undefined, mensagem: 'Possuo uma dublagem desse título.'}});
    },
    goToMedia(){
      return scrollPageTo('#midias');
    },
    goToElencoDublagem(){
      return scrollPageTo('#elenco_dublagem');
    }
  }
};
</script>
<style scoped>
  .movie-title {
    line-height: 1.1;
  }

  .aka {
    white-space: pre-wrap; 
    word-wrap: break-word;
    line-height: 1;
    display: block;
    margin-top: 15px;
  }

  .movie-title span {
    font-size: 0.65em;
    margin-top: 15px;
  }

  .custom-padding-bottom-cover {
    padding-bottom: 1.5rem;
  }
  .ph-title {
    height: 35px;
  }
  .ph-subtitle {
    height: 25px;
    margin-bottom: 25px;
  }
  .ph-text {
    height: 15px;
  }
  .ph-cover {
    height: 700px;
    margin-bottom: -5px;
  }

  @media screen and (max-width: 992px) {
    .capa-filme {
      max-width: 211px;
      margin: 0 auto;
      margin-bottom: 45px;
    }
    .ph-cover {
      height: 313px;
    }
    .movie-title {
      text-align: center;
    }
    .categoria, .dublagem {
      text-align: center;
    }

    .dublagem .badge {
      margin: 0 auto;
    }
  }
</style>
